export function visitorGrantReady(
  requestedScopes: readonly string[],
  grant: { status: string; scopes: readonly string[] } | null | undefined
): boolean {
  return (
    grant?.status === "connected" &&
    [...grant.scopes].sort().join(" ") === [...requestedScopes].sort().join(" ")
  );
}
